module.exports = __webpack_public_path__ + "static/media/opensuse_overlay-fs8.5fffd3bb.png";